export type PendingAction =
  | { type: 'view_asset'; assetId: string }
  | { type: 'create' }
  | { type: 'follow'; username: string }
  | { type: 'save'; assetId: string };

const KEY = 'spinit_pending_action';
const ALLOWED = new Set(['view_asset', 'create', 'follow', 'save']);

export function setPendingAction(action: PendingAction) {
  if (!ALLOWED.has(action.type)) return;
  sessionStorage.setItem(KEY, JSON.stringify(action));
}

export function readPendingAction(): PendingAction | null {
  const raw = sessionStorage.getItem(KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as PendingAction;
    if (!ALLOWED.has(parsed.type)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export const getPendingAction = readPendingAction;

export function clearPendingAction() {
  sessionStorage.removeItem(KEY);
}

export function resumePath(action: PendingAction): string {
  switch (action.type) {
    case 'view_asset':
      return `/spin/${action.assetId}`;
    case 'create':
      return '/create';
    case 'follow':
      return `/channel/${action.username}`;
    case 'save':
      return `/library?highlight=${action.assetId}`;
    default:
      return '/';
  }
}
